import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ProductSuggestionFragment = { id: string, text: string, specific: { id: string, shortName: string, product: { id: string, pk: number, thumbnailUrl: string | null } | null } | null };

export const ProductSuggestionFragmentDoc = gql`
    fragment ProductSuggestionFragment on ProductSuggestionType {
  id
  text
  specific {
    id
    shortName
    product {
      id
      pk
      thumbnailUrl(method: CROP, size: "60x0")
    }
  }
}
    `;